<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <app-select
                        @input="change"
                        ref="val"
                        label="Type"
                        :error="appError"
                        placeholder="Type"
                        name="type"
                        id="type"
                        :is-multiple="false"
                        :use-search="false"
                        :options="appOptions"
                        :value="appValue"
                    ></app-select>
                </div>
            </div>
            <div v-if="activeFolder" class="col-12">
                <div class="form-group">
                    <app-input
                        :error="appInputError"
                        name="emails"
                        id="emails"
                        label="Emails (write separated by commas ,)"
                        placeholder="Emails (write separated by commas ,)"
                        :value="appInputValue"
                    ></app-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            appValue: {
                default: null
            },
            appInputValue: {
                default: null
            },
            appOptions: {
                default: null
            },
            appInputError: {
                default: null
            },
            appError: {
                default: null
            }
        },
        data() {
            return {
                activeFolder: false
            }
        },
        mounted() {
            if(this.appValue == 1) {
                this.activeFolder = true;
            }
        },
        methods: {
            change(value) {
                if(value == 1) {
                    this.activeFolder = true;
                } else {
                    this.activeFolder = false;
                }
            }
        }
    }
</script>
